import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import { checkIsGlanceView } from '@shared/utils'
import useTranslation from 'next-translate/useTranslation'
import { DownloadIcon, WarningIcon } from '@shared/components/ctIcons'

// import useOnMouseAndScroll from '@shared/hooks/useOnMouseAndScroll'

const ListicleArticle = dynamic(() => import('../listicleArticle'))
// const Ads = dynamic(() => import('@shared/components/ads'))
const TipsNote = dynamic(() => import('@shared/components/fantasyTips/tipsNote'))
const CustomLink = dynamic(() => import('@shared/components/customLink'))
const FollowUs = dynamic(() => import('@shared/components/articleDetail/followUs'))
const CommonContent = dynamic(() => import('@shared/components/commonContent'))
// const VuuklePlugin = dynamic(() => import('@shared/components/vuukle-plugin'))
const ArrayHTML = dynamic(() => import('@shared/components/InnerHTML/arrayHTML'))
const PredictionCard = dynamic(() => import('@shared/components/articleDetail/predictionCard'))

function ArticleContent({ article }) {
  const router = useRouter()
  const isMobileWebView = router?.query?.isMobileWebView
  const isMobileWebViewV2 = router?.query?.isMobileWebViewV2
  const { t } = useTranslation()
  const isGlanceView = checkIsGlanceView(router?.query)

  function getAdCode() {
    if (isGlanceView) {
      return {
        1: {
          id: 'div-gpt-ad-5',
          adId: 'Crictracker_mrec_mid',
          dimension: [[300, 250], [336, 280], 'fluid'],
          adUnitName: 'Crictracker_English_InArticleMedium_Mid2',
          placementName: 'InArticleMedium',
          className: 'd-flex justify-content-center mb-3',
          width: 300,
          height: 250,
          // router: { router },
          pageName: 'crictracker.com'
        }
      }
    } else if (isMobileWebViewV2) {
      return {}
    } else if (isMobileWebView && !isMobileWebViewV2) {
      return {
        1: {
          id: 'div-ad-desk-138639789-1684933887-0',
          adIdDesktop: 'crictracker_new_mobile_webapp_ap_mid_300x250',
          dimensionDesktop: [300, 250],
          slotId: '23148549803',
          className: 'text-center mb-3 mb-md-4'
        },
        3: {
          id: 'div-ad-gpt-138639789-Desktop_AP_MID-1646637168-0',
          adIdDesktop: 'crictracker_new_mobile_webapp_ap_mid_300x250',
          dimensionDesktop: [300, 250],
          slotId: '23148549803',
          className: 'text-center mb-3 mb-md-4'
        }
      }
      // return {}
    } else {
      return {
        1: {
          id: 'div-ad-desk-23148549803-1735292575-0',
          adIdDesktop: 'Crictracker_New_Test_Video_1x1',
          adIdMobile: 'Crictracker_New_Test_Video_1x1',
          hidePreview: true,
          dimensionDesktop: [1, 1],
          dimensionMobile: [1, 1],
          mobile: true,
          hideOn: 'none',
          slotId: '23148549803',
          className: 'text-center mb-3 mb-md-4 p-0 bg-transparent'
        },
        // 1: {
        //   id: 'div-ad-desk-138639789-1684933887-0',
        //   adIdDesktop: 'Crictracker_New_Desktop_AP_MID_728x90',
        //   adIdMobile: 'Crictracker_New_Mobile_AP_MID1_300x250',
        //   dimensionDesktop: [728, 90],
        //   slotId="23148549803"
        //   dimensionMobile: [300, 250],
        //   mobile: true,
        //   hideOn: 'none',
        //   className: 'text-center mb-3 mb-md-4'
        // },
        3: {
          id: 'div-ad-gpt-138639789-Desktop_AP_MID-1646637168-0',
          adIdDesktop: 'Crictracker_New_Desktop_AP_BTF_728x90',
          adIdMobile: 'Crictracker_New_Mobile_AP_MID2_300x250',
          slotId: '23148549803',
          dimensionDesktop: [728, 90],
          dimensionMobile: [300, 250],
          mobile: true,
          className: 'text-center mb-3 mb-md-4'
        },
        6: {
          id: 'div-ad-gpt-138639789_Desktop_AP_MID2_728-46637168-0',
          adIdDesktop: 'Crictracker_New_Desktop_AP_BTF_728x90',
          adIdMobile: 'Crictracker_New_Mobile_AP_ATF_300x250',
          slotId: '23148549803',
          dimensionDesktop: [728, 90],
          dimensionMobile: [300, 250],
          mobile: true,
          className: 'text-center mb-3 mb-md-4'
        },
        9: {
          id: 'div-ad-fixedAd10',
          adIdDesktop: 'Crictracker_New_Desktop_AP_BTF_728x90',
          adIdMobile: 'Crictracker_New_Mobile_AP_ATF_300x250',
          slotId: '23148549803',
          dimensionDesktop: [728, 90],
          dimensionMobile: [300, 250],
          mobile: true,
          className: 'text-center mb-3 mb-md-4'
        },
        11: {
          id: 'div-ad-fixedAd12',
          adIdDesktop: 'Crictracker_New_Desktop_AP_BTF_728x90',
          adIdMobile: 'Crictracker_New_Mobile_AP_ATF_300x250',
          slotId: '23148549803',
          dimensionDesktop: [728, 90],
          dimensionMobile: [300, 250],
          mobile: true,
          className: 'text-center mb-3 mb-md-4'
        }
      }
    }
  }
  function getArticleContent() {
    if (article?.bIsListicleArticle) {
      return <ListicleArticle article={article} />
      // } else if (article?.iEventId) {
      //   return (
      //     <>
      //       {article?.oLiveArticleContent?.sFirstContent ? (
      //         <CommonContent>
      //           <InnerHTML className={`${styles.content} text-break`} id="content" html={article?.oLiveArticleContent?.sFirstContent} />
      //         </CommonContent>
      //       ) : null}
      //       <div className={styles.content}>
      //         <h4>Follow all the live action here!</h4>
      //         {/* <CommonContent> */}
      //         <LiveArticle
      //           liveArticleList={article?.oLiveArticleList}
      //           liveArticleEvent={article?.oLiveArticleEvent}
      //           liveEventId={article?.iEventId}
      //         />
      //         {/* </CommonContent> */}
      //       </div>
      //       {article?.oLiveArticleContent?.sLastContent ? (
      //         <CommonContent>
      //           <InnerHTML className={`${styles.content} text-break`} id="content" html={article?.oLiveArticleContent?.sLastContent} />
      //         </CommonContent>
      //       ) : null}
      //     </>
      //   )
    } else {
      return (
        <CommonContent id="content">
          <ArrayHTML data={article?.aContent} article={article} customAds={getAdCode()} />
          {/* <InnerHTML
            className={`${styles.content} text-break`} id="content"
            // html={addEditorAds(addAdsInsideParagraph(article?.sContent, [0, 1, 2, 5]))}
            html={addEditorAds(addAdsInsideParagraph(article?.sContent, [1, 3, 6, 9, 11], isGlanceView ? 0 : 1))}
          /> */}
        </CommonContent>
      )
    }
  }

  const Tag = (p) => (
    <CustomLink
      key={p?.item?._id}
      target="_blank"
      className={`badge bg-primary m-1 font-semi py-1 px-3 ${p?.item?.eStatus === 'i' ? 'disabled' : ''}`}
      href={'/' + p?.item?.oSeo?.sSlug}
      prefetch={false}
    >
      {p?.item?.sName}
    </CustomLink>
  )

  return (
    <>
      {getArticleContent()}
      {article?.bIsCricketPredictionEnabled && (
        <>
          <PredictionCard article={article} />
          <TipsNote
            heading={t('common:Disclaimer')}
            headingIcon={<WarningIcon />}
            descText="The prediction is based on the understanding, analysis, and instinct of the author. While making your prediction, consider the points mentioned, and make your own decision."
            className="pt-0"
          />
        </>
      )}
      {/* {isLoaded && <VuuklePlugin article={article} id={article?._id} />} */}
      {!isGlanceView && !isMobileWebView && (
        <>
          <FollowUs className="my-3 my-lg-4" />
          <TipsNote heading={t('common:DownloadOurApp')} headingIcon={<DownloadIcon />} isDownloadAppDisclaimer className="pt-0 pb-3" />
        </>
      )}
      <div className="d-flex flex-lg-wrap pb-2 pb-lg-0 mx-n1 overflow-auto">
        {article?.aSeries?.map((item, index) => (
          <Tag key={item?._id} item={item} index={index} />
        ))}
        {article?.aTeam?.map((item, index) => (
          <Tag key={item?._id} item={item} index={index} />
        ))}
        {article?.aPlayer?.map((item, index) => (
          <Tag key={item?._id} item={item} index={index} />
        ))}
        {article?.aTags?.map((item, index) => (
          <Tag key={item?._id} item={item} index={index} />
        ))}
      </div>
    </>
  )
}
ArticleContent.propTypes = {
  article: PropTypes.object
}

export default ArticleContent
